import React, { useState } from 'react'
import Modal from 'react-bootstrap-modal'
import StringMatch from './matches/string-match'
import DateMatch from './matches/date-match'
import MultiMatch from './matches/multi-match'
import PriceMatch from './matches/price-match'
import BoolMatch from './matches/bool-match'

const Filters = ({filters, locations, regions, onClose, onApply}) => {
  const [tmpFilters, setTmpFilters] = useState(filters) 
  const columnsValues = [
    ['name', 'Event Name'], ['date_with_time', 'Event Date/Time'],
    ['location_id', 'Facility'], ['region_id', 'Region'],
    ['facility_pay_payment_type', 'How Did We Pay?'],
    ['facility_pay_paid_at', 'When Did We Pay?'],
    ['(revenue - received)', 'Unpaid'],
    ['requires_captain', 'Requires Captain'],
    ['has_captain', 'Has Captain']
  ]
  const paymentTypes = [
    'Daily', 'Weekly', 'Monthly', 'Pending Payment', 'CC',
    'CC Pending', 'Melio', 'Zelle', 'Bi-Weekly', 'Free Game'
  ]
  const paymentTypesOptions = paymentTypes.map((val, i) => [val, val])
  const typeValues = ['and', 'or']

  const addNewRow = () => {
    const type = tmpFilters.length ? 'and' : null
    setTmpFilters([...tmpFilters, {type: type, column: columnsValues[0][0]}])
  }

  const removeRow = (index) => {
    const result = [...tmpFilters.slice(0, index), ...tmpFilters.slice(index + 1, tmpFilters.length)]
    if (index == 0 && result.length) result[0].type = null
    setTmpFilters(result)
  }

  const updateRow = (index, data) => {
    setTmpFilters([
      ...tmpFilters.slice(0, index),
      data,
      ...tmpFilters.slice(index + 1, tmpFilters.length)
    ])
  }

  const transformRow = (index, value) => {
    setTmpFilters([
      ...tmpFilters.slice(0, index),
      {type: tmpFilters[index].type, column: value},
      ...tmpFilters.slice(index + 1, tmpFilters.length)
    ])
  }

  const optionsForColumn = (column) => {
    switch(column) {
      case 'location_id':
        return locations
      case 'region_id':
        return regions
      case 'facility_pay_payment_type':
        return paymentTypesOptions
    }
  }

  const displayFilters = () => {
    return tmpFilters.map((value, i) => {
      switch(value.column) {
        case 'name':
          return <StringMatch
            key={i}
            data={value}
            types={typeValues}
            columns={columnsValues}
            onRemove={() => removeRow(i)}
            onChange={data => updateRow(i, data)}
            onTransform={column => transformRow(i, column)}
          />
        case 'date_with_time':
        case 'facility_pay_paid_at':
          return <DateMatch
            key={i}
            data={value}
            types={typeValues}
            columns={columnsValues}
            onRemove={() => removeRow(i)}
            onChange={data => updateRow(i, data)}
            onTransform={column => transformRow(i, column)}
          />
        case 'location_id':
        case 'region_id':
        case 'facility_pay_payment_type':
          return <MultiMatch
            key={i}
            data={value}
            types={typeValues}
            columns={columnsValues}
            values={optionsForColumn(value.column)}
            onRemove={() => removeRow(i)}
            onChange={data => updateRow(i, data)}
            onTransform={column => transformRow(i, column)}
          />
        case '(revenue - received)':
          return <PriceMatch
            key={i}
            data={value}
            types={typeValues}
            columns={columnsValues}
            values={optionsForColumn(value.column)}
            onRemove={() => removeRow(i)}
            onChange={data => updateRow(i, data)}
            onTransform={column => transformRow(i, column)}
          />
        case 'has_captain':
        case 'requires_captain':
          return <BoolMatch
            key={i}
            data={value}
            types={typeValues}
            columns={columnsValues}
            values={optionsForColumn(value.column)}
            onRemove={() => removeRow(i)}
            onChange={data => updateRow(i, data)}
            onTransform={column => transformRow(i, column)}
          />
      }
    })
  }

  return (
    <Modal container={document.body} show={true} onHide={onClose} className='reconciliations-filter'>
      <Modal.Header closeButton>
        <Modal.Title>Filters</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='filters'>
          <div className='filters__list'>
            {displayFilters()}
          </div>
          <div className='filters__actions'>
            <div className='add-condition' onClick={addNewRow}>+ Add condition</div>
            <div className='buttons'>
              <button className='btn btn-default' onClick={onClose}>Cancel</button>
              <button className='btn btn-info' onClick={() => onApply(tmpFilters)}>Apply</button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default Filters
